<template>
  <!-- post弹框 -->
  <a-modal
    v-model="visible"
    title=""
    :centered="true"
    :footer="null"
    :maskClosable="false"
    dialogClass="global-campaign-post-modal-class"
    :closable="false"
  >
    <div class="modal-con" :class="[lang]">
      <div class="post-title">{{ $t('postModalTitle') }}</div>
      <div class="people-box">
        <div class="people-left">
          <div class="people-item">
            <div class="people-item-label">{{ $t('postModalLabel1') }}：</div>
            <div class="people-item-txt">33</div>
          </div>
          <div class="people-item">
            <div class="people-item-label">{{ $t('postModalLabel2') }}：</div>
            <div class="people-item-txt">30</div>
          </div>
          <div class="people-item">
            <div class="people-item-label">{{ $t('postModalLabel3') }}：</div>
            <div class="people-item-txt">{{ $t('postModalLabelTxt') }}</div>
          </div>
        </div>
        <div class="people-icon">
          <img src="@/assets/img/post-modal-icon@2x.png" alt="">
          <div class="icon-txt">{{ $t('postModalIconTxt') }}</div>
        </div>
        <div class="people-right">
          <div class="people-item">
            <div class="people-item-label">{{ $t('postModalLabel1') }}：</div>
            <div class="people-item-txt">{{ $t('postModalLabelTxt2') }}</div>
          </div>
          <div class="people-item">
            <div class="people-item-label">{{ $t('postModalLabel2') }}：</div>
            <div class="people-item-txt">{{ $t('postModalLabelTxt2') }}</div>
          </div>
          <div class="people-item">
            <div class="people-item-label">{{ $t('postModalLabel3') }}：</div>
            <div class="people-item-txt">{{ $t('postModalLabelTxt1') }}</div>
          </div>
        </div>
      </div>
      <div class="post-con beauty-scroll" :class="{
        'post_con_more': isShowMoreCon
      }">
        <div class="con-txt" v-html="modal_con" :class="[lang]">
        </div>
        <div class="con-hidden-btn" v-if="!isShowMoreCon">
          <div class="hidden-btn-txt" @click="showMoreCon" :class="[lang]">{{ $t('postModalAllBtn') }}</div>
        </div>
      </div>
      <div class="btn-box">
        <div class="btn" @click="saveCompaign('1')" :class="[lang]">{{ $t('postModalBtnTxt') }}</div>
      </div>
      <div class="btn-txt-box">
        <span @click="saveCompaign('0')" :class="[lang]">{{ $t('postModalBtnTxt1') }}</span>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    postModalCon: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShowMoreCon: false
    }
  },
  i18n: require("./posti18n"),
  computed: {
    ...mapState("setting", ["lang"]),
    visible: {
      get () {
        return this.showModal
      },
      set (val) {
        this.$emit('update:showModal', val)
      }
    },
    modal_con () {
      return this.getCon(this.postModalCon)
    }
  },
  mounted () {},
  methods: {
    saveCompaign (postType) {
      this.$emit('publishDirectly', postType)
    },
    getCon (text) {
      return text.replace(/\n/g, '<br />');
    },
    showMoreCon () {
      this.isShowMoreCon = true
    }
  }
}
</script>

<style lang="less" scoped>
.modal-con {
  padding: 32px;
  .post-title {
    padding: 0 70px;
    font-weight: bold;
    font-size: 28px;
    color: #1B776E;
    line-height: 38px;
    margin-bottom: 58px;
    text-align: center;
  }
  .people-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    .people-left {
      width: 340px;
      min-width: 340px;
      height: 172px;
      background: #F3F3F3;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #D9D9D9;
      padding: 22px;
    }
    .people-right {
      width: 340px;
      min-width: 340px;
      height: 172px;
      background: #FFFFFF;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #D9D9D9;
      padding: 22px;
      .people-item-txt {
        color: #1B776E !important;
      }
    }
    .people-item {
      display: flex;
      .people-item-label {
        color: #919191;
      }
      .people-item-txt {
        color: #000000;
      }
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 32px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .people-icon {
      text-align: center;
      img {
        width: 32px;
        height: auto;
      }
      .icon-txt {
        font-weight: bold;
        font-size: 14px;
        color: #0E756A;
        line-height: 20px;
        margin-top: 12px;
      }
    }
  }
  .post-con {
    width: 100%;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #D9D9D9;
    padding: 18px 46px 18px 18px;
    position: relative;
    overflow: hidden;
    height: 202px;
    &.post_con_more {
      max-height: 202px;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .con-txt {
      font-weight: bold;
      font-size: 14px;
      color: #000000;
      line-height: 28px;
    }
    .con-hidden-btn {
      font-weight: bold;
      font-size: 14px;
      color: #1B9DE1;
      line-height: 20px;
      padding: 20px 18px 24px;
      background: #fff;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 10px;
      .hidden-btn-txt {
        cursor: pointer;
      }
    }
  }
  .btn-box {
    text-align: center;
  }
  .btn {
    padding: 0 54px;
    height: 42px;
    line-height: 40px;
    margin: 26px 0 20px 0;
    font-weight: bold;
    background: #0e756a;
    color: #fff;
    border-radius: 4px;
    display: inline-block;
    cursor: pointer;
  }
  .btn-txt-box {
    text-align: center;
    font-weight: bold;
    font-size: 14px;
    color: #1B776E;
    line-height: 20px;
    span {
      cursor: pointer;
    }
  }
  @media screen and (min-height: 700px) {
    .post-con.post_con_more {
      max-height: calc(100vh - 512px);
    }
  }
}
</style>
<style lang="less">
.global-campaign-post-modal-class {
  width: 900px !important;
  padding: 0 !important;
  .ant-modal-body {
    padding: 0;
    position: relative;
  }
  .ant-modal-close {
    right: -4px;
    top: -2px;
  }
}
</style>
